import { SVGProps } from "react";

export function EarthIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7 12.25C9.8995 12.25 12.25 9.8995 12.25 7C12.25 4.1005 9.8995 1.75 7 1.75C4.1005 1.75 1.75 4.1005 1.75 7C1.75 9.8995 4.1005 12.25 7 12.25Z"
        stroke="#7A7A7A"
        strokeWidth="1.16667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.09961 5.25H11.8996"
        stroke="#7A7A7A"
        strokeWidth="1.16667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.09961 8.75H11.8996"
        stroke="#7A7A7A"
        strokeWidth="1.16667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.70879 1.75C5.72607 3.32477 5.20508 5.14375 5.20508 7C5.20508 8.85625 5.72607 10.6752 6.70879 12.25"
        stroke="#7A7A7A"
        strokeWidth="1.16667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.29102 1.75C8.27373 3.32477 8.79473 5.14375 8.79473 7C8.79473 8.85625 8.27373 10.6752 7.29102 12.25"
        stroke="#7A7A7A"
        strokeWidth="1.16667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
